import React from "react";
import { List, Empty } from 'antd'
import NotificationItem from 'ui/components/notificationItem';
import { noteList as strings } from 'ui/constants/strings';

const { Item } = List;

class NotificationList extends React.PureComponent {

  onRemoveNotification = (id) => {
    const { onRemove } = this.props;
    onRemove(id);
  };

  renderNotificationItem = (item) => {
    const { families } = this.props;
    return (
      <Item>
        <NotificationItem type="close" onRemove={this.onRemoveNotification} {...item} families={families} />
      </Item>
    )
  }

  render() {
    const { notifications } = this.props;
    const haveNotifications = notifications.length > 0;
    if (haveNotifications) {
      return (
        <List
          className='fullContent'
          dataSource={notifications}
          renderItem={this.renderNotificationItem}
        />
      )
    }

    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <span>
            {strings.nullscreenText}
          </span>
        }
      />
    )
  }
}

export default NotificationList;
